import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const isLocalOrPreview = () => {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h.includes("emergentagent.com");
};

export const submitNetlify = async (formName, fields, file) => {
  if (isLocalOrPreview()) return false;
  try {
    let res;
    if (file) {
      const fd = new FormData();
      fd.append("form-name", formName);
      Object.entries(fields).forEach(([k, v]) => fd.append(k, String(v)));
      fd.append("resume", file);
      res = await fetch("/", { method: "POST", body: fd });
    } else {
      const body = {};
      Object.entries(fields).forEach(([k, v]) => {
        body[k] = String(v);
      });
      res = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ "form-name": formName, ...body }).toString(),
      });
    }
    return res.ok;
  } catch (_) {
    return false;
  }
};

export const submitBackend = async (payload) => {
  if (!BACKEND_URL) return false;
  try {
    const res = await axios.post(`${BACKEND_URL}/api/contact`, payload);
    return Boolean(res.data && res.data.ok);
  } catch (_) {
    return false;
  }
};
